import { createSlice } from '@reduxjs/toolkit';
import { TableState } from '../../components/table/model';

const initialState: TableState = {
  columns: [],
};

const partnerconnectionendpointListSlice = createSlice({
  name: 'partnerconnectionendpointTable',
  initialState,
  reducers: {
    hideColumn(state) {},
  },
});

export const partnerconnectionendpointsReducer = partnerconnectionendpointListSlice.reducer;
